import { FC } from 'react';
import styles from './TrendsSpinner.css';
import { Spinner } from '@cian/ui-kit';

export const TrendsSpinner: FC = () => {
  return (
    <div data-testid="TrendsSpinnerId" className={styles['container']}>
      <div className={styles['spinner']}>
        <Spinner size={32} color="icon-main-default" />
      </div>
    </div>
  );
};
